<template>
  <section class="content">
    <vue-headful title="QB-STATISTICS | Modules"></vue-headful>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Module Configuration</h3>
        <div class="box-tools">
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="box-toolbar">
          <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#addModuleModal"><i class="fa fa-plus mr-5"></i>Add new module</button>
          </div>
          <links-box></links-box>
        </div>
        <div class="row">
          <div class="col-sm-6"></div>
          <div class="col-sm-6">
            <div class="dataTables_filter form-inline">
              <label>Search:</label>
              <input type="search" class="form-control input-sm" placeholder aria-controls="users" v-model="filter">
            </div>
          </div>
        </div>
        <b-table :items="items" :fields="fields" :filter="filter">
          <template v-slot:cell(view)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'read')" class="btn btn-default btn-sm" data-toggle="modal" data-target="#editModuleModal" @click="updateModule(data.item.id)"><i class="fa fa-pencil mr-5"></i>Bearbeiten</button>
          </template>
          <template v-slot:cell(delete)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'delete')" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#deleteModuleModal" @click="deleteModule(data.item.id)"><i class="fa fa-trash mr-5"></i>Löschen</button>
          </template>
        </b-table>
      </div>
    </div>
    <div class="modal fade" id="addModuleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Add new Module</h4>
          </div>
          <div class="modal-body">
            <form action="#" method="post" class="form-horizontal">
              <div class="form-group">
                <label for="newModuleName" class="control-label col-sm-4">Module Name:</label>
                <div class="col-sm-8"><input type="text" id="newModuleName" placeholder="Module Name" class="form-control" v-model="newModule.name"></div>
              </div>
              <div class="form-group">
                <label for="newModuleComponent" class="control-label col-sm-4">Component:</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="newModule.component" id="newModuleComponent">
                    <option>Select Component</option>
                    <option v-for="c in moduleComponents" :value="c">{{c}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" ref="closeCreate" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-primary" @click="saveProp">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editModuleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Module Bearbeiten</h4>
          </div>
          <div class="modal-body">
            <form action="#" method="post" class="form-horizontal">
              <div class="form-group">
                <label for="moduleID" class="control-label col-sm-4">Module ID:</label>
                <div class="col-sm-8"><input type="text" id="moduleID" placeholder="Module ID" class="form-control" v-model="moduleForUpdate.id" disabled></div>
              </div>
              <div class="form-group">
                <label for="moduleName" class="control-label col-sm-4">Module Name:</label>
                <div class="col-sm-8"><input type="text" id="moduleName" class="form-control" v-model="moduleForUpdate.name"></div>
              </div>
              <div class="form-group">
                <label for="type" class="control-label col-sm-4">Component:</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="moduleForUpdate.component">
                    <option v-for="o in moduleComponents" :value="o">{{o}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeEdit"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-primary" @click="saveModuleUpdate">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-danger fade" id="deleteModuleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Delete Module</h4>
          </div>
          <div class="modal-body text-center" v-if="items && moduleForDelete !== ''">
            <h3 class="">
              Are you sure you want to delete the Module "{{items.find(r => {return r.id === moduleForDelete}).value}}"?
            </h3>
            <p class="text-bold text-danger"><i class="fa fa-warning mr-5"></i>This change is irreversible!</p>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeDelete"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-danger" @click="onOk">Delete<i class="fa fa-trash ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import Api from '@/services/Api'
  export default {
    name: "ModuleManager",
    data () {
      return {
        filter: '',
        fields: [
          {key: 'id', label: 'Module ID'},
          {key: 'value', label: 'Module name'},
          {key: 'view', label: 'Edit'},
          {key: 'delete', label: 'Delete'}
        ],
        newModule: {},
        moduleComponents: ['BarChart', 'Filters', 'DataTable', 'LineChart', 'PieChart'],
        creating: false,
        enableEdit: false,
        moduleForDelete:'',
        display: false,
        userPermissions: this.$store.getters.permissions,
        moduleForUpdate: {},
        showButton: false,
        msOptions: [],
        properties: [],
        selectedProp: '',
        selectedName: '',
        items: [],
        fullOptions: [],
        newProp: {},
        icons: {
          user: 'fa fa-user',
          role: 'fa fa-tasks',
          salesChannel: 'fa fa-sitemap',
          company: 'fa fa-building-o',
          userType: 'fa fa-address-book-o',
          module: 'fa fa-cubes',
          page: 'fa fa-file-text-o',
          store: 'fa fa-home'
        }
      }
    },
    methods: {
      getData () {
        axios.all([Api().get(`/frontend/permission/base`), Api().get(`/frontend/navigation/module/list`)])
          .then(axios.spread((...responses) => {
            this.msOptions = responses[0].data
            Object.keys(responses[0].data).forEach(d => {
              this.newProp[d] = false
            })
            this.items = responses[1].data
          })).catch(errors => {
        })
      },
      updateModule (id) {
        Api().get(`/frontend/navigation/module?id=${id}`)
          .then(res => {
            this.moduleForUpdate = res.data
          })
      },
      onOk () {
        Api().delete(`/frontend/navigation/module?id=${this.moduleForDelete}`)
          .then(res => {
            Api().get(`/frontend/navigation/module/list`)
              .then(response => {
                this.items = response.data
                this.moduleForDelete = ''
                this.$refs.closeDelete.click()
              })
          })
          .catch(error => {
            this.confirmOpen = false
          })
      },
      deleteModule (id) {
        this.moduleForDelete = id
      },
      saveProp () {
        Api().post(`/frontend/navigation/module`, this.newModule)
          .then(response => {
            Api().get(`/frontend/navigation/module/list`)
              .then(res => {
                this.$refs.closeCreate.click()
                this.items = res.data
              })
          })
          .catch(error => {
          })
      },
      saveModuleUpdate () {
        Api().put(`/frontend/navigation/module`, this.moduleForUpdate)
          .then(res => {
            Api().get(`/frontend/navigation/module/list`)
              .then(res => {
                this.$refs.closeEdit.click()
                this.items = res.data
              })
          })
      },
      getPermissionsIDs (arr) {
        let retArr = []
        for (let r in arr) {
          for (let a in arr[r]) {
            arr[r][a].forEach(p => {
              if (!retArr.includes(p.id)) {
                retArr.push(p.id)
              }
            })
          }
        }
        return retArr.join(',')
      },
      checkIfDisabled (id, action) {
        if (action in this.userPermissions.role) {
          let a = this.userPermissions['role'][action].find(x => x.value === id || x.value === 'all')
          return typeof a === 'undefined'
        }
        return true
      },
      getPermissions (resource, action) {
        if (this.roleForUpdate.permissions[resource]) {
          return this.roleForUpdate.permissions[resource][action] || []
        }
        return []
      }
    },
    beforeCreate() {
      this.$store.dispatch('userHasPermission', {type: 'role', action: 'create', scope: 'all'})
        .then(res => {
          this.showButton = res
        })
    },
    mounted () {
      this.getData()
    }
  }
</script>
<style>
  .nav-tabs .nav-link.active {
    border-color: #dee2e6 #dee2e6 #fff !important;
    color: white;
    background-color: #292a31;
    border-radius: 2px !important;
    border: 1px solid !important;
    border-bottom: #292a31 !important;
  }
  .nav-tabs .nav-item {
    margin-bottom: -3px !important;
  }
  .card-header {
    margin-bottom: 0;
    background-color: rgba(0,0,0,.03);
  }
  .card-header {
    background-color: grey;
    color: black ;
  }
  .nav.nav-tabs.card-header-tabs {
    border-bottom: 1px solid white;
  }
  div.dataTables_filter {
    text-align: right;
  }
  div.dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left;
  }
  div.dataTables_filter input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto;
  }
</style>
